import {
  AutocompleteArrayInput as AutocompleteArrayInputRA,
  AutocompleteArrayInputProps as AutocompleteArrayInputRaProps,
} from 'react-admin';

import { CommonInputProps } from './types';
import WithInfoTooltip from 'src/components/WithInfoTooltip';

interface AutocompleteArrayInputProps extends AutocompleteArrayInputRaProps, CommonInputProps {}

export const AutocompleteArrayInput = ({ infoTooltip, sx, ...rest }: AutocompleteArrayInputProps) => {
  const inputProps = {
    sx: {
      flex: infoTooltip ? 1 : undefined,
      ...sx,
    },
    ...rest,
  };

  if (!infoTooltip) return <AutocompleteArrayInputRA {...inputProps} />;

  return (
    <WithInfoTooltip title={infoTooltip} sx={{ ml: 1 }}>
      <AutocompleteArrayInputRA {...inputProps} />
    </WithInfoTooltip>
  );
};

export default AutocompleteArrayInput;
